import React, { useState } from 'react';
import { EnergyFeedbackType } from '@demind-inc/core';
import { Typography } from '@mui/material';
import { motion, AnimatePresence } from 'framer-motion';

import './EventEnergyFeedback.scss';
import { mdiFire } from '@mdi/js';
import Icon from '@mdi/react';
import { EnergyFeedback } from '../../../Energy';
import { HelpOutline } from '@mui/icons-material';
import { CustomTooltip, CustomTooltipContent } from '../../../common';
import { emaExplanationInfo } from './constants';
import { getEmaDoneText } from './helpers';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

interface EventEnergyFeedbackProps {
  selectedFeedback?: EnergyFeedbackType;
  onSelectFeedback: (feedback: EnergyFeedbackType) => void;
  isDisabled?: boolean;
  hideIcon?: boolean;
  prefixText?: string;
  className?: string;
  width?: number | string;
}

const EventEnergyFeedback: React.FC<EventEnergyFeedbackProps> = ({
  selectedFeedback,
  onSelectFeedback,
  isDisabled,
  hideIcon = false,
  prefixText,
  className,
  width = 250,
}) => {
  const { t } = useTranslation();
  const [isTextVisible, setIsTextVisible] = useState(false);

  const handleSelectFeedback = (feedback: EnergyFeedbackType) => {
    onSelectFeedback(feedback);
    setIsTextVisible(true);

    setTimeout(() => {
      setIsTextVisible(false);
    }, 3000);
  };
  return (
    <div className={clsx('event-energy-feedback', className)}>
      {!hideIcon && (
        <Icon path={mdiFire} size="32px" className="event-energy-feedback__icon" />
      )}
      <div className="event-energy-feedback__content">
        <p className="event-energy-feedback__content__title">
          {prefixText}
          {t('calendar.eventMenu.energyQuestion')}
          <CustomTooltip
            title={
              <CustomTooltipContent
                {...emaExplanationInfo}
                title={t('calendar.eventMenu.subjectiveEnergyAdjustmentTitle')}
                description={t('calendar.eventMenu.subjectiveEnergyAdjustmentDescription')}
              />
            }
          >
            <HelpOutline fontSize="inherit" width={6} />
          </CustomTooltip>
        </p>
        <EnergyFeedback
          selectedFeedback={selectedFeedback}
          onFeedbackSelect={handleSelectFeedback}
          disabled={isDisabled}
          width={width}
        />
        {selectedFeedback && isTextVisible && (
          <AnimatePresence>
            <motion.div
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.3, ease: 'easeOut' }}
              className="event-energy-feedback__done-text"
            >
              <Typography variant="body2" className="event-energy-feedback__done-text-content">
                {getEmaDoneText(t, selectedFeedback)}
              </Typography>
            </motion.div>
          </AnimatePresence>
        )}
      </div>
    </div>
  );
};

export default EventEnergyFeedback;
